import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "font-weight-regular opacity-90"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-center dil-container"
}

import {Drive} from "@/types/Drive";
import DIL_Switches from "@/components/misc/DIL_Switches.vue";
import {decimalToBinaryArray, useGlobalSetting} from "@/lib/utils";
import {ref, shallowRef} from "vue";
import {DataTableHeader} from "vuetify/lib/components/VDataTable/types";
import {Header} from "@/lib/types";

interface Tab {
  icon: string;
  text: string;
  value: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DriveInformationDialog',
  props: /*@__PURE__*/_mergeModels({
    headers: {},
    readonly: { type: Boolean },
    onClose: { type: Function }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const model = _useModel<Drive>(__props, "modelValue");

const props = __props;

const currentTab = shallowRef<string>('tab-1')

const tabs: Tab[] = [
  {
    icon: 'mdi mdi-information-slab-box',
    text: 'Allgemeines',
    value: 'general'
  },
  {
    icon: 'mdi-flash',
    text: 'Elektrisches',
    value: 'electrical'
  },
  {
    icon: 'mdi-shield-check',
    text: 'Safety',
    value: 'safety'
  },
  {
    icon: 'mdi-dots-horizontal',
    text: 'Sonstiges',
    value: 'misc'
  },
]

const dil = ref<Array<Boolean>>(decimalToBinaryArray(model.value.safety_code));

const getUnitFromKey = (key: string): string => {
  if(model.value == null) return '';
  if (key === "systemVoltage")
    return model.value.systemVoltageUnit
  if (key === "systemPower")
    return model.value?.systemPowerUnit
  if (key === "systemCurrent")
    return model.value?.systemCurrentUnit
  if (key === "systemNominalSpeed")
    return " " + model.value?.systemNominalSpeedUnit
  return ""
}

function close() {
  props.onClose?.();
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "d-flex flex-column",
    height: "100vh"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, { class: "flex-grow-1 overflow-auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar, {
            color: model.value?.is_safety ? 'safety' : 'primary',
            density: "compact",
            class: "px-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: "mdi-engine",
                class: "mr-2"
              }),
              _createVNode(_component_v_toolbar_title, { class: "text-subtitle-1 font-weight-medium" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(model.value?.asset_id) + " ", 1),
                  (model.value?.description_primary)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, " - " + _toDisplayString(model.value.description_primary), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(_component_v_tabs, {
            modelValue: currentTab.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentTab).value = $event)),
            items: tabs,
            "align-tabs": "center",
            color: "primary",
            height: "60",
            "slider-color": "primary"
          }, {
            tab: _withCtx(({ item }) => [
              _createVNode(_component_v_tab, {
                "prepend-icon": item.icon,
                text: item.text,
                value: item.value,
                class: "text-none",
                disabled: item.value == 'safety' && !model.value?.is_safety
              }, null, 8, ["prepend-icon", "text", "value", "disabled"])
            ]),
            item: _withCtx(({ item }) => [
              _createVNode(_component_v_tabs_window_item, {
                value: item.value,
                class: "pa-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.headers.filter(h => h.tab == item.value), (header) => {
                            return (_openBlock(), _createBlock(_component_v_col, {
                              key: header.key,
                              cols: "12",
                              md: "6"
                            }, {
                              default: _withCtx(() => [
                                (header.key === 'dil')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                      _createVNode(_component_v_icon, {
                                        class: "mr-7",
                                        icon: "mdi-toggle-switch",
                                        size: "24",
                                        style: {"color":"rgb(121,121,121)"}
                                      }),
                                      (model.value?.is_safety)
                                        ? (_openBlock(), _createBlock(DIL_Switches, {
                                            key: 0,
                                            modelValue: dil.value,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dil).value = $event)),
                                            readonly: props.readonly,
                                            class: "flex-grow-1 mt-2 mb-2"
                                          }, null, 8, ["modelValue", "readonly"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (!header.checkbox)
                                    ? (_openBlock(), _createBlock(_component_v_text_field, {
                                        key: 1,
                                        clearable: !props.readonly,
                                        label: `${header.title}`,
                                        "model-value": `${model.value[header.key]}${getUnitFromKey(header.key)}`,
                                        "prepend-icon": header.icon,
                                        readonly: props.readonly,
                                        variant: _unref(useGlobalSetting)().globalTextVariant
                                      }, null, 8, ["clearable", "label", "model-value", "prepend-icon", "readonly", "variant"]))
                                    : (_openBlock(), _createBlock(_component_v_switch, {
                                        key: 2,
                                        color: header.key === 'is_safety' ? 'yellow' : 'primary',
                                        label: header.title,
                                        "model-value": model.value[header.key],
                                        "prepend-icon": header.icon,
                                        readonly: props.readonly,
                                        class: "flex-no-grow",
                                        density: "compact",
                                        "hide-details": "",
                                        inset: ""
                                      }, null, 8, ["color", "label", "model-value", "prepend-icon", "readonly"]))
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["value"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, { class: "bg-surface-light" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, { onClick: close }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: "black",
                icon: "mdi-close-circle-outline",
                start: ""
              }),
              _cache[2] || (_cache[2] = _createTextVNode(" Schließen "))
            ]),
            _: 1,
            __: [2]
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})